/**
 * Returns `true` when the Hub space density (spacing) customization should be
 * available.
 *
 * Space density is a sub-feature of advanced theming and is available whenever
 * advanced theming is enabled.
 *
 * Cross-host safe: returns `false` when HubContext is not mounted (Confluence
 * Company Hub, CSM, etc.) because `useIsAdvancedThemingEnabled` returns false in
 * that case.
 */
import { useIsAdvancedThemingEnabled } from '../use-is-advanced-theming-enabled';

export const useIsHubSpaceDensityEnabled = (): boolean => useIsAdvancedThemingEnabled();
